import React from 'react';
import PropTypes from 'prop-types';
const _ = {
    find:       require('lodash/find'),
    get:       require('lodash/get'),
};

const Globals = require('../../../../app/globals');
const Strings = require('../../../../app/shared/Strings');
import withAllShortCourseLicenseData from '../DataHOCs/WithAllShortCourseLicenseData';
import CoursePurchasePage from './CoursePurchasePage';
import SkillBuildLogo from './SkillBuildLogo';
import NotFound from '../NotFound';
import LicenseTile from './LicenseTile';
import StringUtil from '../../../../app/shared/StringUtil';
const TEMPsortCourseLicenses = require('../../util/SortUtil').TEMPsortCourseLicenses;

const propTypes = {
    className: PropTypes.string,
    userInfo: PropTypes.object.isRequired,
    role: PropTypes.string.isRequired,
    courseId: PropTypes.string,
    onSelectCourse: PropTypes.func.isRequired,
    gotoExploreRootView: PropTypes.func.isRequired, // function to return to this view if in a course 
    goBack: PropTypes.func.isRequired,
    licenses: PropTypes.arrayOf(PropTypes.shape({
        token: PropTypes.string.isRequired,
        cost: PropTypes.number.isRequired,
        license_type_token: PropTypes.oneOf([Globals.ecommerce.course_license_types.INDIVIDUAL, Globals.ecommerce.course_license_types.INSTITUTION]),
        course_title: PropTypes.string.isRequired,
        course_display_title: PropTypes.string,
        course_hash: PropTypes.string.isRequired,
        course_image_url: PropTypes.string,
        course_description: PropTypes.string,
        course_license_meta_data: PropTypes.shape({
            subcompetency: PropTypes.bool,
        }).isRequired,
        issued_at: PropTypes.string,
        expires_at: PropTypes.string,
    })).isRequired,
};
const defaultProps = {
    className: '',
};


class ExploreDashboard extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {};
    }
    
    render() {
        const instructorLicenses = this.props.licenses.filter(license => license.license_type_token === Globals.ecommerce.course_license_types.INSTITUTION);
        if (this.props.courseId) {
            const license = _.find(instructorLicenses, { token: this.props.courseId });
            if (!license) {
                return <NotFound />;
            }
            
            // const licenseCourseTitle = license.course_display_title || license.course_title || '';
            return (
                <div className={`student courses-dashboard ${this.props.className}`}>
                    <div className="courses-dashboard__content">
                        <div className="courses-heading">
                            <SkillBuildLogo />
                            <div className="courses-heading__desc">
                                <span dangerouslySetInnerHTML={StringUtil.dangerouslyCreateMarkup(Strings['en'].short_course.skillbuild.SKILLBUILD_DESC_INST)} />
                            </div>
                        </div>
                        {/*<div className="courses-dashboard__breadcrumbs">
                            <span>{Strings['en'].dashboard.COURSES}</span>
                            <span className="fa fa-chevron-right"/>
                            <span className="content-tile__link" aria-role="button" onClick={this.props.goBack}>{Strings['en'].dashboard.SKILLBUILD}</span>
                            <span className="fa fa-chevron-right"/>
                            <span>{licenseCourseTitle}</span>
                        </div>*/}
                        <CoursePurchasePage
                            userInfo={this.props.userInfo}
                            role={this.props.role}
                            license={license}
                            gotoExploreRootView={this.props.gotoExploreRootView}
                        />
                    </div>
                </div>
            );
        }
        
        const competencyLicenses = [];
        const subcompetencyLicenses = [];
        instructorLicenses.forEach((license) => {
            if (_.get(license, 'course_license_meta_data.subcompetency', false)) {
                subcompetencyLicenses.push(license);
            }
            else {
                competencyLicenses.push(license);
            }
        });
        const sortedSubcompetencyLicenses = TEMPsortCourseLicenses(subcompetencyLicenses);
        return (
            <div className={`student courses-dashboard ${this.props.className}`}>
                <div className="courses-dashboard__content">
                    <div className="courses-heading">
                        <SkillBuildLogo />
                        <div className="courses-heading__desc">
                            <span dangerouslySetInnerHTML={StringUtil.dangerouslyCreateMarkup(Strings['en'].short_course.skillbuild.SKILLBUILD_DESC_INST)} />
                        </div>
                    </div>                              
                    {(competencyLicenses.length === 0 && sortedSubcompetencyLicenses.length === 0) ?
                        <div className='available-courses__comingsoon'>
                            {Strings['en'].common.COMING_SOON}
                        </div>
                        :
                        <div className="available-courses">
                            <div className="available-courses__competency">
                                {competencyLicenses.map((license) => {
                                    return (
                                        <LicenseTile
                                            key={license.token}
                                            license={license}
                                            interactable
                                            onSelect={this.props.onSelectCourse.bind(this, license.token)}
                                        />
                                    );
                                })}
                            </div>
                            <div className="available-courses__subcompetency">
                                {sortedSubcompetencyLicenses.map((license) => {
                                    return (
                                        <LicenseTile
                                            key={license.token}
                                            license={license}
                                            interactable
                                            onSelect={this.props.onSelectCourse.bind(this, license.token)}
                                        />
                                    );
                                })}
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

ExploreDashboard.propTypes = propTypes;
ExploreDashboard.defaultProps = defaultProps;

export default withAllShortCourseLicenseData(ExploreDashboard);
